import { MerchantHomePage } from "./../merchant-home/merchant-home";
import { Storage } from "@ionic/storage";
import { ViewHeaderPage } from "./../view-header/view-header";
// import { MerchantRentalRentPage } from "./../merchant-rental-rent/merchant-rental-rent";
import { MerchantRentalYourspacePage } from "./../merchant-rental-yourspace/merchant-rental-yourspace";
import { Component } from "@angular/core";
import {
  IonicPage,
  LoadingController,
  NavController,
  NavParams,
} from "ionic-angular";
import { ServiceProvider } from "../../providers/service/service";
import { RequestOptions, Http, Headers } from "@angular/http";
import { MerchantRentalRentInputPage } from "../merchant-rental-rent-input/merchant-rental-rent-input";

@IonicPage()
@Component({
  selector: "page-merchant-rental",
  templateUrl: "merchant-rental.html",
})
export class MerchantRentalPage {
  plaza = "A";
  url: any;
  budget: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private storage: Storage,
    private loadingCtrl: LoadingController,
    private services: ServiceProvider,
    private http: Http
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    const loader = this.loadingCtrl.create({
      content: "Loading...",
    });
    loader.present();
    this.storage.get("token").then((token) => {
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.storage.get("info").then((info) => {
        if (info.team.plaza_id == 1) {
          this.plaza = "A";
        } else if (info.team.plaza_id == 2) {
          this.plaza = "B";
        } else if (info.team.plaza_id == 3) {
          this.plaza = "C";
        } else if (info.team.plaza_id == 4) {
          this.plaza = "D";
        } else if (info.team.plaza_id == 5) {
          this.plaza = "E";
        } else if (info.team.plaza_id == 6) {
          this.plaza = "F";
        } else {
          this.plaza = info.team.plaza_id;
        }

        if (info.role == 1) {
          this.url = this.services.URLPlazaStatBudgets;
        } else if (info.role == 2) {
          this.url = this.services.URLMerchantStatBudgets;
        } else if (info.role == 3) {
          this.url = this.services.URLShopperStatBudgets;
        }
        var link = this.url;

        this.http
          .get(link, requestOptions)
          .map((res) => res.json())
          .subscribe(
            (data) => {
              this.budget = this.services.currencyFormat(data.available);
              loader.dismiss();
            },
            (error) => {
              // console.log(error);
              this.services.presentToastInternet();
              loader.dismiss();
            }
          );
      });
    });
  }

  rentSpace() {
    this.navCtrl.push(MerchantRentalRentInputPage);
  }

  yourShop() {
    this.navCtrl.push(MerchantRentalYourspacePage);
  }

  backPage() {
    this.navCtrl.push(MerchantHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.push(MerchantHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/merchant-rental/merchant-rental.ts